
import { claimReturnTreasure, getReturnTreasureReward } from '@/api/activity'
import { useUserStore } from '@/stores/user'

export function useReturnTreasureService(
    showError: (msg: string) => void,
    showSuccess: (msg: string) => void,
    loadingRef: any,
) {

    const userStore = useUserStore()

    // Get Rewards API
    const fetchRewardInfo = async () => {
        loadingRef.value.open()
        try {
            const res = await getReturnTreasureReward({ user_id: userStore.id })
            loadingRef.value.close()
            return {
                rewardAmount: res.data?.reward_amount || 0,
                rewardTimes: res.data?.times || 0,
                rewardType: res.data?.rewardType || 1,
                fixedRechargeConfigs: res.data?.fixedRechargeConfigs || []
            }
        } catch (err: any) {
            if (err.code !== 401) showError(err)
            loadingRef.value.close()
            throw err
        }
    }

    // Claim Reward API
    const claimReward = async () => {
        loadingRef.value.open()
        try {
            const res = await claimReturnTreasure({ user_id: userStore.id })
            showSuccess(res.msg)
            userStore.getInfo()
            loadingRef.value.close()
            return res
        } catch (err: any) {
            if (err.code !== 401) showError(err)
            loadingRef.value.close()
            throw err
        }
    }

    return {
        fetchRewardInfo,
        claimReward
    }
}